module.exports = __webpack_public_path__ + "dist/jaana_jokinen.8b5aa01b.png";